import { render, staticRenderFns } from "./BusinessViewRateForm.vue?vue&type=template&id=f9742f12&"
import script from "./BusinessViewRateForm.vue?vue&type=script&lang=js&"
export * from "./BusinessViewRateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VAlert,VRating})
